<template>
  <a-spin :spinning="loading">
    <vxe-grid
        ref="xGrid"
        column-key
        class="column-sortable-grid"
        v-bind="gridOptions"
        @cell-click="cellClick"
        @cell-dblclick="cellDbClick"
        :footer-method="footerMethod"
        :show-footer="showFooter"
        :auto-resize="true"
        @edit-closed="(e)=>{$emit('edit-closed',e)}"
    >
      <template v-slot:default="{ row }">
        <slot name="operate" v-bind:row="row"></slot>
      </template>
      <template v-slot:toolbar_buttons>
        <slot v-if="toolbarConfig&&toolbarConfig.templatelSlots"
              :name="toolbarConfig&&toolbarConfig.templatelSlots"></slot>
      </template>

      <!--   子表自定义插槽  -->
      <template v-for="item in slotsRules" v-slot:[item]>
        <slot :name="item"></slot>
      </template>
      <!--   用于图片展示的插槽   -->
      <template v-slot:pics="{ row,column}">
        <a v-if="row[column.property]" :href="api.temp.FILE_PATH + row[column.property]" target="_blank">
          <img v-if="row[column.property].toLowerCase().includes('.png')||
                    row[column.property].toLowerCase().includes('.jpg')||
                    row[column.property].toLowerCase().includes('.jpeg')||
                    row[column.property].toLowerCase().includes('.gif')"
               :src="api.temp.FILE_PATH + row[column.property]" style="height: 30px;"/>
          <a-icon v-else-if="row[column.property].toLowerCase().includes('.ogm')||
                           row[column.property].toLowerCase().includes('.wmv')||
                           row[column.property].toLowerCase().includes('.mpg')||
                           row[column.property].toLowerCase().includes('.webm')||
                           row[column.property].toLowerCase().includes('.ogv')||
                           row[column.property].toLowerCase().includes('.mov')||
                           row[column.property].toLowerCase().includes('.asx')||
                           row[column.property].toLowerCase().includes('.mpeg')||
                           row[column.property].toLowerCase().includes('.mp4')||
                           row[column.property].toLowerCase().includes('.m4v')||
                           row[column.property].toLowerCase().includes('.avi')" type="video-camera" title="点击预览"/>
          <a-icon v-else type="picture" title="点击预览"/>

        </a>
      </template>
      <!--   用于上传文件的插槽   -->
      <template v-slot:upload="{ row,column }">
        <a-upload
            :action="api.temp.UPLOAD_PATH"
            :headers="headers"
            :accept="'*'"
            :multiple="false"
            @change="handleChange($event,row,column.property)"
            :showUploadList="false"
        >
          <vxe-button size="mini">重新上传</vxe-button>
        </a-upload>
      </template>
    </vxe-grid>
  </a-spin>
</template>

<script>
import Vue from "vue";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import api from "@/services/api";

import VXETablePluginAntd from 'vxe-table-plugin-antd';
import 'vxe-table-plugin-antd/dist/style.css';
import XEUtils from "xe-utils";

VXETable.use(VXETablePluginAntd);

Vue.use(VXETable);

/**
 * 如果value值有效(除了null/undefined/NaN之外的所有值)则返回value，否则返回defaultValue
 * @param value
 * @param defaultValue
 * @returns
 */
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" || value === null || isNaN(value)
      ? defaultValue
      : value;
}

/**
 * 工厂方法，用来提供各种设置的默认值
 */
const factory = {
  /**
   * 生成一个序号列
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param width 50
   * @returns {}
   */
  makeColumnSeqDefault(width = 50) {
    return {type: "seq", title: '序号', width: width, align: "center"};
  },

  /**
   * 根据类型生成首列选择栏r>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param type 选择框内容 默认为checkbox
   * @returns {}
   */
  makeColumnDefault(type = 'checkbox') {
    if (type === 'radio') {
      return {type: "radio", field: '#', width: 50, align: "center"};
    } else {
      return {type: "checkbox", field: '#', width: 50, align: "center"};
    }
  },
  /**
   * 生成一个空的checkbox列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @param width 默认为40
   * @returns {}
   */
  makeColumnCheckboxDefault(field = "#", width = 50) {
    return {type: "checkbox", field: field, width: width, align: "center"};
  },
  /**
   * 生成一个空的radio列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @param width 默认为40
   * @returns {}
   */
  makeColumnRadioDefault(field = "#", width = 50) {
    return {type: "radio", field: field, width: width, align: "center"};
  },
  /**
   * 创建列定义
   * @param field 字段名，或者一个column对象（如果使用column对象，则只能传一个参数）
   * @param title 标题
   * @param width
   * @param align
   * @param resizable 是否可调整大小
   * @param formatter
   * @param type
   * @param sortable
   * @param filters
   * @returns {{formatter: null, field: *, resizable: boolean, width: (*|number), sortable: boolean, filters: *[], title: *, align: string, type: null, filterMultiple: boolean}|any}
   */
  makeColumn(
      field,
      title,
      width,
      align = "left",
      resizable = true,
      formatter = null,
      type = null,
      // sortable = false,
      // filters = []
  ) {
    if (arguments.length === 1 && typeof field == "object" && field) {
      // 传入column object，则添加一些默认值
      return Object.assign(
          {
            field: field.field,
            title: field.title || field.field,
            width: field.width,
            resizable: valueOrDefault(field.resizable, true),
            headerAlign: 'center'
            // sortable: valueOrDefault(field.sortable, false),
          },
          field
      );
    } else {
      // 传入参数表
      return {
        field,
        title: title || field,
        width:
            width === null || typeof width === "undefined" ? width : width || 100,
        align,
        resizable,
        formatter,
        type,
        headerAlign: 'center'
        // sortable,
        // filters,
        // filterMultiple: false,
      };
    }
  },
  /**
   * 获取工具栏配置
   * @param buttons 按钮列表
   * @returns
   */
  makeToolbarConfig(buttons = {}) {
    return Object.assign({}, {
      slots: {
        buttons: 'toolbar_buttons'
      },
      refresh: false,
      import: false,
      export: false,
      print: false,
      zoom: false,
      custom: false,
    }, buttons);
  },
  /**
   * 创建插槽配置
   */
  makeSlotsConfig(columns) {
    let slots = [];
    columns.forEach((val) => {
      if (val.slots && val.slots.default) {
        slots.push(val.slots.default)
      }
    })
    return slots;
  },

  makeEditConfig() {
    return {
      trigger: "click",
      mode: "row",
      showStatus: true,
    };
  },
  makeEditRuleRequired(messageOrColumn) {
    return {
      required: true,
      message:
          typeof messageOrColumn === "string"
              ? messageOrColumn
              : (messageOrColumn.title || messageOrColumn.field) + "必须填写",
    };
  },
  makeEditRuleRange(messageOrColumn, min, max) {
    return {
      min,
      max,
      message:
          typeof messageOrColumn === "string"
              ? messageOrColumn
              : (messageOrColumn.title || messageOrColumn.field) +
              `长度应在${min}-${max}字符之间`,
    };
  },
  /**
   * 根据列定义的editRules构建标准editRules配置<br>
   * @param columns 列定义 [{ field: '', editRules: [{ required: true }, { min: 0, max: 1 }, ...] }]
   * @returns { COLUMN_FILED: [ RULE1, RULE2, ... ], ... }
   */
  makeEditRules(columns) {
    const rules = {};
    columns.forEach((col) => {
      if (col.editRules) {
        if (!XEUtils.isArray(col.editRules)) {
          console.warn("列定义的editRules应是一个数组");
        } else {
          rules[col.field] = col.editRules.map((rule) => {
            if (rule) {
              const editRule = Object.assign({}, rule);
              if (typeof rule.required === "boolean") {
                editRule.message = `${col.title || col.field}必填`;
              } else if (
                  typeof rule.min === "number" ||
                  typeof rule.max === "number"
              ) {
                editRule.message = `${col.title ||
                col.field}长度应在${rule.min || 0}-${rule.max || 0}之间`;
              } else {
                console.info("不支持的editRule", rule);
              }
              return editRule;
            }
          });
        }
      }
    });
    return rules;
  },
};

/**
 * 组件定义
 */
export default {
  components: {},
  props: {
    id: String,
    columnResizable: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showHeaderOverflow: {
      type: Boolean,
      default: true,
    },
    showOverflow: {
      type: Boolean,
      default: true,
    },
    highlightHoverRow: {
      type: Boolean,
      default: true,
    },
    keepSource: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 400,
    },
    /**
     * 数据集
     */
    data: Array,
    /**
     * 列定义
     */
    columns: Array,
    /**
     * 工具栏配置<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/toolbar<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/customToolbar<br>
     * {
     *   buttons: [
     *     { code: 'myInsert', name: '新增', status: 'success', disabled: false },
     *     ...
     *   ],
     *   refresh: true,
     *   import: true,
     *   export: true,
     *   print: true,
     *   zoom: true,
     *   custom: true
     * }
     */
    toolbarConfig: Object,
    /**
     * 是否可编辑，如果设置为true，则默认生成单击行编辑的editConfig
     */
    editConfig: Object,

    /**
     * 编辑规则
     *
     */
    editRules: Object,
    editable: {
      type: Boolean,
      default: null,
    },
    /**
     * 单元格单击操作
     */
    cellClick: {
      type: Function,
      default() {
        return ''
      }
    },
    /**
     * 子表表尾
     */
    footerMethod: {
      type: Function,
      default() {
        return ''
      }
    },
    /**
     * 单元格双击时打开详情
     */
    cellDbClick: {
      type: Function,
      default() {
        return ''
      }
    },
    /**
     * 自定义插槽 用于循环自定义插槽
     */
    slotsRules: {
      type: Array,
      default() {
        return []
      }
    },
  },
  computed: {
    headers() {
      return {
        token: localStorage.getItem('token') || ''
      }
    }
  },
  data() {
    // console.info("XGrid data =", this.data);
    return {
      api,
      loading: false,
      gridOptions: {
        border: this.border,
        resizable: this.columnResizable,
        showHeaderOverflow: this.showHeaderOverflow,
        showOverflow: this.showOverflow,
        highlightHoverRow: this.highlightHoverRow,
        keepSource: this.keepSource,
        id: this.id,
        height: this.height,
        toolbarConfig: this.toolbarConfig,
        columns: this.columns,
        data: this.data,
        editRules: this.editRules,
        editConfig:
            this.editable || (this.editable !== false && this.editConfig)
                ? this.editConfig || factory.makeEditConfig()
                : null,
      },

    };
  },
  methods: {
    /**
     * 重新上传
     */
    handleChange({file}, row, type) {
      if (file.status === 'done') {
        let data = file.response.data;
        this.$emit('uploadRowsFile', data.url, row, type);
      }
    },
    insertAt(insertArr, index) {
      this.$refs['xGrid'].insertAt(insertArr, index);
    }
  },
  factory: factory,
};
</script>

<style scoped>
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-ghost,
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}

.column-sortable-grid .vxe-header--row .vxe-header--column.col--fixed {
  cursor: no-drop;
}
</style>
